import { useCallback } from 'react'
import { useStateValue } from '../../../services/state/StateProvider'
import { chain, isEmpty, has, map, forEach } from 'lodash'

export const useUpdateBannersAnimations = () => {
  const [_, dispatch] = useStateValue()

  const updateBannersAnimations = useCallback(
    banners => {
      let animations = {}

      if (!isEmpty(banners)) {
        forEach(banners, banner => {
          chain(banner)
            .map(slot => {
              return map(slot.slot, s => {
                return s.content
              })
            })
            .flatten()
            .filter(['type', 'animation'])
            .forEach(layer => {
              // TODO: refactor to also use absolute urls
              fetch(`${process.env.PUBLIC_URL}/content/animations/${layer.anim}.json`)
                .then(response => {
                  response
                    .json()
                    .then(frames => {
                      if (!has(animations, layer.anim)) {
                        animations[layer.anim] = frames
                      }

                      dispatch({
                        type: 'storeAnimations',
                        casino: {
                          animations: animations
                        }
                      })
                    })
                    .catch(() => {
                      console.log(`[Casino] missing animation: ${layer.anim}, skipping...`)
                    })
                })
                // file not found
                .catch(() => {
                  // animation file not found
                })
            })
            .value()
        })
      }
    },
    [dispatch]
  )

  return { updateBannersAnimations }
}
